<template>
    <div>
        <div>
            <TabBasic sub-component toolbar-color="primary" toolbar-text-color="secondary--text">
                <template v-slot:header>
                    {{ $t('zones.geofenceEvent') }} <sup>*</sup>
                </template>
                <v-form @submit="save">
                    <v-row>
                        <v-col class="justify-end" cols="4" md="2">
                            <v-checkbox
                                    v-model="zoneManagement.EventIn"
                                    :label="$t('zones.eventIn')"
                            ></v-checkbox>
                            <v-checkbox
                                    v-model="zoneManagement.EventOut"
                                    :label="$t('zones.eventOut')"
                            ></v-checkbox>
                            <span v-if="errorEvent" class="error--text">{{ $t('zones.youShouldSelectOneEvent') }}</span>
                        </v-col>
                        <v-col cols="8" md="10">
                            <v-select
                                    v-model="zoneManagement.EventInSeverity"
                                    :items="severities"
                                    :rules="[zoneManagement.EventIn ?$validations.required : true]"
                                    class="ml-5">
                                <template v-slot:label>
                                    {{ $t('notifications.severity') }}<sup v-if="zoneManagement.EventIn">*</sup>
                                </template>
                            </v-select>
                            <v-select
                                    v-model="zoneManagement.EventOutSeverity"
                                    :items="severities"
                                    :rules="[zoneManagement.EventOut ? $validations.required : true]"
                                    class="ml-5">
                                <template v-slot:label>
                                    {{ $t('notifications.severity') }}<sup v-if="zoneManagement.EventOut">*</sup>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-form>
            </TabBasic>
        </div>
        <div class="mt-2">
            <TabBasic sub-component toolbar-color="primary" toolbar-text-color="secondary--text">
                <template v-slot:header>
                    {{ $t('zones.monitoredMembers') }}
                </template>
                <v-form>
                    <v-row>
                        <v-col>
                            <div class="d-flex align-center">
                                <v-text-field
                                        v-model="searchMonitoredUsers"
                                        class="datatable-search"
                                        dense
                                        hide-details
                                        outlined
                                        prepend-inner-icon="mdi-magnify"/>
                                <div class="ml-4">
                                    <v-btn class="accent" icon rounded @click="addMonitoredUsers">
                                        <v-icon color="accentText">mdi-plus</v-icon>
                                    </v-btn>
                                </div>
                            </div>

                            <v-data-table
                                    :headers="header"
                                    :items="monitoredUsers"
                                    :loading="loading"
                                    :search="searchMonitoredUsers"
                                    class="rounded-lg shadow my-6">
                                <template v-slot:[`item.AvatarUrl`]="{item}">
                                    <v-avatar size="35">
                                        <img
                                                v-if="item.AvatarUrl"
                                                :src="item.AvatarUrl"
                                                alt="avatar">
                                        <v-icon v-else size="50">
                                            mdi-account-circle
                                        </v-icon>
                                    </v-avatar>
                                </template>
                                <template v-slot:[`item.actions`]="{item}">
                                    <TableAction :tooltip="$t('tooltips.delete')" icon="mdi-delete"
                                                 @click="deleteItem(item.UserID, 'Monitored')"/>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-form>
            </TabBasic>
        </div>
        <div>
            <TabBasic sub-component toolbar-color="primary" toolbar-text-color="secondary--text">
                <template v-slot:header>
                    {{ $t('zones.notificationReceivers') }}
                </template>
                <v-form>
                    <v-row>
                        <v-col>
                            <div class="d-flex align-center">
                                <v-text-field
                                        v-model="searchNotificationUsers"
                                        class="datatable-search"
                                        dense
                                        hide-details
                                        outlined
                                        prepend-inner-icon="mdi-magnify"/>
                                <div class="ml-4">
                                    <v-btn class="accent" icon rounded @click="addNotificationUsers">
                                        <v-icon color="accentText">mdi-plus</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                            <v-data-table
                                    :headers="header"
                                    :items="notificationUsers"
                                    :loading="loading"
                                    :search="searchNotificationUsers"
                                    class="rounded-lg shadow my-6">
                                <template v-slot:[`item.AvatarUrl`]="{item}">
                                    <v-avatar size="35">
                                        <img
                                                v-if="item.AvatarUrl"
                                                :src="item.AvatarUrl"
                                                alt="avatar">
                                        <v-icon v-else size="50">
                                            mdi-account-circle
                                        </v-icon>
                                    </v-avatar>
                                </template>
                                <template v-slot:[`item.actions`]="{item}">
                                    <TableAction :tooltip="$t('tooltips.delete')" icon="mdi-delete"
                                                 @click="deleteItem(item.UserID, 'Receiver')"/>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="text-right">
                            <v-btn
                                    :disabled="!hasChanges && (zoneManagement.EventIn || zoneManagement.EventOut)"
                                    :loading="loading"
                                    class=" py-6 accentText--text shadow-inverse"
                                    color="accent"
                                    depressed
                                    @click="save">
                                {{ $t('save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </TabBasic>
        </div>
        <ZoneManagementAddUsers :open="addUserDialog" :user-type="addUserType" :users="availableUsers"
                                @close="addUserDialog = false" @save="addUsers"/>
        <LeaveConfirmDialog ref="leaveConfirmDialog"/>
    </div>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";
import {
  NOTIFICATIONS_SEVERITY_CRITICAL,
  NOTIFICATIONS_SEVERITY_INFO,
  NOTIFICATIONS_SEVERITY_WARNING,
  USER_ACTIVE,
  ZONE_USER_MONITORED,
  ZONE_USER_RECEIVER
} from "@/helper/constants";
import ZoneManagementAddUsers from "@/components/Zones/ZoneManagementAddUsers";
import {isEqual} from "@/helper/helper";

export default {
  name: "ZoneManagement",
  components: {ZoneManagementAddUsers, TabBasic},
  inject: ['zoneInjection', 'refreshZone'],
  data() {
    return {
      searchMonitoredUsers: '',
      searchNotificationUsers: '',
      errorEvent: false,
      users: [],
      loading: false,
      zoneManagement: {
        monitoredUsersID: [],
        notificationUsersID: [],
        EventInSeverity: NOTIFICATIONS_SEVERITY_INFO,
        EventOutSeverity: NOTIFICATIONS_SEVERITY_INFO,
      },
      oldZoneManagement: {
        monitoredUsersID: [],
        notificationUsersID: [],
        EventInSeverity: NOTIFICATIONS_SEVERITY_INFO,
        EventOutSeverity: NOTIFICATIONS_SEVERITY_INFO,
      },
      addUserDialog: false,
      addUserType: ZONE_USER_MONITORED,
      hasChanges: false,
      validateEvent: false,
    };
  },
  mounted() {
    this.getUsers();
    this.zoneManagement = {...this.zone, ...this.zoneManagement};
    this.oldZoneManagement = {...this.zone, ...this.oldZoneManagement};
    window.addEventListener('keyup', this.save);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.save);
  },
  computed: {
    availableUsers() {
      if (this.addUserType === ZONE_USER_MONITORED) {
        return this.users.filter((user) => !this.zoneManagement.monitoredUsersID.includes(user.UserID) && user.Status === USER_ACTIVE);
      }
      return this.users.filter((user) => !this.zoneManagement.notificationUsersID.includes(user.UserID) && user.Status === USER_ACTIVE);
    },
    severities() {
      return [
        {
          text: this.$t('notifications.info'),
          value: NOTIFICATIONS_SEVERITY_INFO
        },
        {
          text: this.$t('notifications.warning'),
          value: NOTIFICATIONS_SEVERITY_WARNING
        },
        {
          text: this.$t('notifications.critical'),
          value: NOTIFICATIONS_SEVERITY_CRITICAL
        }
      ];
    },
    notificationUsers() {
      return this.users.filter(user => this.zoneManagement.notificationUsersID.includes(user.UserID));
    },
    monitoredUsers() {
      return this.users.filter(user => this.zoneManagement.monitoredUsersID.includes(user.UserID));
    },
    zone() {
      return this.zoneInjection.zone;
    },
    header() {
      return [
        {text: this.$t('circles.avatar'), value: 'AvatarUrl'},
        {text: this.$t('authentication.firstName'), value: 'FirstName'},
        {text: this.$t('authentication.lastName'), value: 'LastName'},
        {text: this.$t('authentication.email'), value: 'Email'},
        {text: '', value: 'actions', sortable: false, align: 'center'},
      ];
    },
  },
  watch: {
    zone: {
      handler(val) {
        this.zoneManagement = {...this.zoneManagement, ...val};
        this.oldZoneManagement = {...this.oldZoneManagement, ...val};
      },
      deep: true,
    },
    zoneManagement: {
      handler() {
        this.hasChanges = !isEqual(this.zoneManagement, this.oldZoneManagement);
        if (this.zoneManagement.EventIn || this.zoneManagement.EventOut) {
          this.validateEvent = true;
        }
        if (!this.zoneManagement.EventIn && !this.zoneManagement.EventOut && this.validateEvent) {
          this.errorEvent = true;
        } else {
          this.errorEvent = false;
        }
      },
      deep: true,
    }
  },
  methods: {
    getUsers() {
      let url = this.$store.getters.getOrganizationUsers(this.$store.getters.getOrganizationId);
      this.axios.get(url).then(({data}) => {
        this.users = data.Result;
        this.loading = false;
      });
      url = this.$store.getters.zoneUsers(this.$route.params.id);
      this.axios.get(url).then(({data}) => {
        this.zoneManagement.monitoredUsersID = data.Result.filter((user) => user.Role === ZONE_USER_MONITORED).map((user) => user.UserID);
        this.zoneManagement.notificationUsersID = data.Result.filter((user) => user.Role === ZONE_USER_RECEIVER).map((user) => user.UserID);
        this.oldZoneManagement.monitoredUsersID = [...this.zoneManagement.monitoredUsersID];
        this.oldZoneManagement.notificationUsersID = [...this.zoneManagement.notificationUsersID];
      });
    },
    addMonitoredUsers() {
      this.addUserType = ZONE_USER_MONITORED;
      this.addUserDialog = true;
    },
    addNotificationUsers() {
      this.addUserType = ZONE_USER_RECEIVER;
      this.addUserDialog = true;
    },
    addUsers(userIDs) {
      if (this.addUserType === ZONE_USER_MONITORED) {
        this.zoneManagement.monitoredUsersID = [...this.zoneManagement.monitoredUsersID, ...userIDs];
      } else {
        this.zoneManagement.notificationUsersID = [...this.zoneManagement.notificationUsersID, ...userIDs];
      }
      this.addUserDialog = false;
    },
    deleteItem(userID, type) {
      if (type === ZONE_USER_MONITORED) {
        const index = this.zoneManagement.monitoredUsersID.indexOf(userID);
        if (index > -1) { // only splice array when item is found
          this.zoneManagement.monitoredUsersID.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        const index = this.zoneManagement.notificationUsersID.indexOf(userID);
        if (index > -1) { // only splice array when item is found
          this.zoneManagement.notificationUsersID.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
    },
    save(e) {
      if (e.key && e.key !== 'Enter' || this.loading) {
        return;
      }
      if (!this.zoneManagement.EventIn && !this.zoneManagement.EventOut) {
        this.errorEvent = true;
      } else {
        this.errorEvent = false;
      }
      if (this.errorEvent) {
        return;
      }
      if (!this.zoneManagement.EventIn && !this.zoneManagement.EventOut || (!this.zoneManagement.EventInSeverity && !this.zoneManagement.EventOutSeverity) || !this.hasChanges) {
        return;
      }
      const url = this.$store.getters.geofence(this.$route.params.id);
      this.loading = true;
      this.axios.put(url, {
        ...this.zoneManagement, Users: [
          ...this.zoneManagement.monitoredUsersID.map(user => ({UserID: user, Role: ZONE_USER_MONITORED})),
          ...this.zoneManagement.notificationUsersID.map(user => ({UserID: user, Role: ZONE_USER_RECEIVER}))
        ]
      }).then(() => {
        this.oldZoneManagement = {...this.zoneManagement};
        this.hasChanges = false;
        this.refreshZone();
        this.$store.dispatch('addNotification',
            {
              type: 'success',
              message: this.$t('success.geofenceWasUpdated')
            });
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges) {
      this.$refs.leaveConfirmDialog.openDialog().then((res) => {
        if (res) {
          next();
        }
        this.next = next;
        next(false);
      });

    } else {
      return next();
    }
  },
};
</script>

<style scoped>

</style>